import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css"; // Import CSS for styling
import Registration from "./Registration";
import VideoSection from "./VideoSection";
import NotificationBell from "../components/NotificationBell";

const gurukuls = [
  { 
    name: "Mayalawas", 
    caption: "A place of wisdom and Vedic learning", 
    image: "mayalawas.jpg", 
    video: "mayalawasF.mp4", 
    path: "/gurukul/mayalawas-gurukul" 
  },
  { 
    name: "Bijrol Kheda", 
    caption: "Where tradition meets excellence", 
    image: "kheda.jpg", 
    video: "mayalawasF.mp4", 
    path: "/gurukul/bijrol-kheda-gurukul" 
  },
  { 
    name: "Tura Sayala", 
    caption: "Nurturing future scholars", 
    image: "sayala.jpg", 
    video: "mayalawasF.mp4", 
    path: "/gurukul/sayala-gurukul" 
  },
  {
    name: "Sawai Choti",
    caption: "Empowering through ancient knowledge",
    image: "churu.jpg",
    video: "mayalawasF.mp4",
    path: "/gurukul/sawai-choti-gurukul"
  },
  {
    name: "Raithal",
    caption: "Primary education with Vedic values",
    image: "raithal1.jpg",
    video: "mayalawasF.mp4",
    path: "/gurukul/raithal-gurukul"
  },
];

// Add this to your imports
const carouselImages = [
  "aboutimg.jpeg",
  "home1.jpg",
  "home2.jpg",
  "home3.jpg",
  "home4.jpg",
  "home6.jpg",
  "home7.jpg",
  // Add more images as needed
];

const Home = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="homeH">
      <div className="homePartH">
        <VideoSection />
        {/* <NotificationBell /> */}
        <Registration />
      </div>

         {/* Updated About Shri Kheteshwar Gurukul Section with Carousel */}
      <div className="about-gurukul-section">
        <div className="about-gurukul-content">
          <h2 className="leaders-titleH">Shri Kheteshwar Gurukul</h2>
          <p>
            Shri Kheteshwar Gurukul is a unique educational institution that harmoniously blends ancient Vedic wisdom with modern academic excellence. 
            Established with the vision of creating spiritually grounded yet professionally capable individuals, our Gurukul provides a transformative 
            learning environment where students grow intellectually, morally, and physically.
          </p>
          <p>
            At Shri Kheteshwar Gurukul, we follow the traditional Gurukul system enhanced with contemporary facilities. Our curriculum includes Vedic studies, 
            Sanskrit, Yoga, and meditation alongside modern subjects like science, mathematics, and computer education. This holistic approach ensures our 
            students become well-rounded individuals who can thrive in any field while maintaining strong cultural roots.
          </p>
          <p>
            The Gurukul boasts experienced teachers, state-of-the-art infrastructure, and a serene natural setting ideal for learning and self-discovery. 
            Through our residential program, students develop discipline, leadership qualities, and lifelong values that prepare them to face global 
            challenges while preserving India's rich spiritual heritage.
          </p>
        </div>
        
        {/* Image Carousel */}
        <div className="about-gurukul-carousel">
          {carouselImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Gurukul ${index + 1}`}
              className={`carousel-image ${index === currentImageIndex ? 'active' : ''}`}
            />
          ))}
        </div>
      </div>

      <div className="gurukul-containerH">
        {gurukuls.map((gurukul, index) => (
          <div
            key={index}
            className="gurukul-cardH"
            onClick={() => navigate(gurukul.path)}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
          >
            {hovered === index ? (
              <video src={gurukul.video} autoPlay loop muted className="gurukul-mediaH" />
            ) : (
              <img src={gurukul.image} alt={gurukul.name} className="gurukul-mediaH" />
            )}
            <div className="gurukul-infoH">
              <h3 className="gurukul-nameH">{gurukul.name}</h3>
              <p className="gurukul-captionH">{gurukul.caption}</p>
            </div>
          </div>
        ))}
      </div>


    


      {/* Leaders Section */}
      <div className="leaders-container">
        <h2 className="leaders-title">Our Visionary Leaders</h2>
        <div className="leaders-section">

          <div className="leader-card">
            <img src="tulsaramjiM.jpg" alt="Param Pujya Shri Shri Tulcharam Ji Maharaj" className="leader-img" />
            <div className="leader-info">
              <h3 className="leader-name">Param Pujya Shri Shri Tulcharam Ji Maharaj</h3>
              <p className="leader-role">Chairman</p>
              <p className="leader-description">
                A guiding force dedicated to preserving Vedic education and instilling spiritual wisdom for future generations.
              </p>
            </div>
          </div>

          
          <div className="leader-card">
            <img src="dhaynam.jpg" alt="Vedantacharya Dr. Dhyanaram Ji Maharaj" className="leader-img" />
            <div className="leader-info">
              <h3 className="leader-name">Vedantacharya Dr. Dhyanaram Ji Maharaj</h3>
              <p className="leader-role">Co-Chairman</p>
              <p className="leader-description">
                Guiding the institution with a vision of excellence, tradition, and modern spiritual leadership.
              </p>
            </div>
          </div>
        </div>
      </div>



    </div>
  );
};

export default Home;
